import * as React from "react"
import { Input } from "../../../ui/input"
import { cn } from "../../../../lib/utils"

export interface DocumentNumberInputProps
  extends Omit<React.InputHTMLAttributes<HTMLInputElement>, "type"> {}

export const DocumentNumberInput = React.forwardRef<HTMLInputElement, DocumentNumberInputProps>(
  ({ className, ...props }, ref) => {
    return (
      <Input
        type="number"
        className={cn(className)}
        ref={ref}
        {...props}
      />
    )
  }
)
DocumentNumberInput.displayName = "DocumentNumberInput"

